function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { debounce } from 'lodash';
import { useSelector } from 'react-redux';
import { usePreviousDistinct } from 'react-use';
import { PRODUCT_TYPE } from '../../../constants/product';
import { RESET_FORM_DELAY } from '../../../pages/constants';
import { selectionNameSchema } from '../../../validation/job';
import ProductIndicator from '../../productMenu/ProductIndicator';
import Cell from '../../table/Cell';
import { MapViewContext } from '../mapViewContext';
import LayerProductMenu from './LayerProductMenu';
import { Button } from 'react-bootstrap';
import { CTX_TRIGGERS } from '../contextMenu/ContextMenu';
import Icon from '../../icon/Icon';
/* eslint-disable react/prop-types */ var Layer = function(param) {
    var data = param.data, index = param.index, onMenuClick = param.onMenuClick;
    var _data_name;
    // To be backwards compatible with previous jobs
    var name = (_data_name = data.name) !== null && _data_name !== void 0 ? _data_name : "Shape ".concat(index + 1);
    var _useContext = useContext(MapViewContext), actions = _useContext.actions, state = _useContext.state;
    var previousName = usePreviousDistinct(name);
    var _useState = _sliced_to_array(useState(false), 2), isNameFocused = _useState[0], setIsNameFocused = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isSuccess = _useState1[0], setIsSuccess = _useState1[1];
    var isQuotingJob = useSelector(function(reduxState) {
        return {
            isQuotingJob: reduxState.jobsReducer.isQuotingJob
        };
    }).isQuotingJob;
    var inputNameRef = useRef();
    var dropdownRef = useRef();
    var productMenuRef = useRef();
    // wrap in a useCallback to memoize the function
    // React guarantees that setState function identity is stable
    // (i.e. won't change on re-renders) so we can omit it from the
    // dependency list
    // note: debounce() and RESET_FORM_DELAY are also stable so omitted
    // so this whole function can be cached once on mount and reused forever
    var debounceSetIsSuccess = useCallback(// debounce delays the given function
    // until after some wait time has elapsed
    debounce(function(value) {
        return setIsSuccess(value);
    }, RESET_FORM_DELAY));
    var handleMouseEnter = useCallback(function() {
        if (data.visible) {
            actions.setHoveredData({
                id: data.id,
                selected: true
            });
        }
    }, [
        data
    ]);
    var handleMouseLeave = useCallback(function() {
        if (data.visible) {
            actions.setHoveredData(null);
        }
    }, [
        data
    ]);
    var handleClick = function(event) {
        var _dropdownRef_current, _inputNameRef_current, _productMenuRef_current;
        if (((_dropdownRef_current = dropdownRef.current) === null || _dropdownRef_current === void 0 ? void 0 : _dropdownRef_current.contains(event.target)) || ((_inputNameRef_current = inputNameRef.current) === null || _inputNameRef_current === void 0 ? void 0 : _inputNameRef_current.contains(event.target)) || ((_productMenuRef_current = productMenuRef.current) === null || _productMenuRef_current === void 0 ? void 0 : _productMenuRef_current.contains(event.target))) {
            return;
        }
        // TODO: don't register a click if this selection is already active
        if (data.category_name === PRODUCT_TYPE.UNKNOWN) {
            actions.clearProductSelected();
        }
        actions.makeSelectionActive(data);
    };
    var handleSubmitName = useCallback(function(name) {
        actions.setSelections(state.selections.map(function(selection) {
            return _object_spread_props(_object_spread({}, selection), {
                name: selection.id === data.id ? name : selection.name
            });
        }));
    }, [
        data,
        state.selections
    ]);
    useEffect(function() {
        if (previousName && name !== previousName) {
            setIsSuccess(true);
        }
        debounceSetIsSuccess(false);
    }, [
        previousName,
        name
    ]);
    return /*#__PURE__*/ React.createElement("li", {
        className: classNames('layer', {
            isFocused: data.focused
        }, data.category_name),
        key: data.id,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: handleClick
    }, data.focused ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Cell, {
        ref: inputNameRef,
        className: "layer-name",
        validationSchema: selectionNameSchema,
        isSuccessful: isSuccess,
        disabled: isQuotingJob,
        value: name,
        onSubmit: handleSubmitName,
        onBlur: function() {
            return setIsNameFocused(false);
        },
        onFocus: function() {
            return setIsNameFocused(true);
        }
    }), !isNameFocused && /*#__PURE__*/ React.createElement("div", {
        className: "layer-actions"
    }, /*#__PURE__*/ React.createElement(Button, {
        className: "Toggle meatball-dropdown btn",
        onClick: function(e) {
            return onMenuClick(e, data.id, CTX_TRIGGERS.lhsDropdown);
        }
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "more",
        style: {
            pointerEvents: 'none'
        }
    })), /*#__PURE__*/ React.createElement(LayerProductMenu, {
        ref: productMenuRef,
        data: data
    }))) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "layer-name"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "layer-name-text"
    }, name)), /*#__PURE__*/ React.createElement("div", {
        className: "layer-actions"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "indicator-wrapper"
    }, /*#__PURE__*/ React.createElement(ProductIndicator, {
        categoryName: data.category_name,
        isSecondary: true
    })))));
};
export default Layer;
